import React, { useState, useEffect } from 'react';
import {
  Pressable,
  View
} from 'react-native';

import { useTranslation } from 'react-i18next';

import IngredientsList from '../../common/components/IngredientsList';
import Ingredient from '../../common/components/Ingredient';
import Tile from '../../common/components/Tile';
import ingredient_styles from '../../common/components/IngredientStyles';
import common_styles from '../../common/components/CommonStyles';

import Cross from '../../assets/Cross';

import {
  Body1,
  XSmall
} from '../../utils';
import { useTheme } from '../../utils/Theme';
import { NotificationSeverity } from '../../common/constants/';

const IngredientSearchState = Object.freeze({"INACTIVE": 0, "ACTIVE_LOADING": 1, "ACTIVE_IDLE": 2});

const NewIngredient = ({name, onPress}) => {
  const { t } = useTranslation('common');

  const theme = useTheme();

  return (
    <Pressable
      style={[
        ingredient_styles.ingredientBase,
        theme.card
      ]}
      onPress={onPress}
    >
      <Tile>
        <View style={ingredient_styles.ingredientBody}>
          <View/>
          <XSmall style={[theme.cardBody, ingredient_styles.ingredientText, {opacity: 1.0}]} numberOfLines={2}>
            { name }
          </XSmall>
          <XSmall style={[theme.cardBody, ingredient_styles.ingredientText]} numberOfLines={1}>
            { t('ingredients.createNewIngredientActionLabel') }
          </XSmall>
        </View>
      </Tile>
    </Pressable>
  );
};


const IngredientPicker = ({
  current_search_phrase,
  results,
  postIngredient,
  pushNotification,
  ingredientSearch,
  setIngredientSearchResults,
  addIngredient,
  deleteIngredient,
  setIngredientsSearchPhrase,
  onPick,
  mode
}) => {
  const [search_state, setSearchState] = useState(IngredientSearchState.INACTIVE);

  const ingredients_search_results = results.ingredients;

  const { t } = useTranslation('common');

  const theme = useTheme();

  useEffect(() => {
    if (!current_search_phrase) {
      setSearchState(IngredientSearchState.INACTIVE);
      if (current_search_phrase !== results.search_phrase) {
        // Reset search results.
        setIngredientSearchResults(current_search_phrase, []);
      }
    } else {
      setSearchState(IngredientSearchState.ACTIVE_IDLE);
      if (current_search_phrase !== results.search_phrase) {
        setSearchState(IngredientSearchState.ACTIVE_LOADING);
        ingredientSearch(current_search_phrase);
      }
    }
  }, [current_search_phrase, results.search_phrase, results.ingredients, setIngredientSearchResults, ingredientSearch/*, query.required_ingredients , loadSuggestedIngredients */]);

  let body = null;
  if (search_state === IngredientSearchState.INACTIVE) {
    // pass
  } else if (search_state === IngredientSearchState.ACTIVE_LOADING) {
    body = (<Body1 style={theme.general}>{t('common.loading')}</Body1>);
  } else {
    const ingredients_list = ingredients_search_results.map((ingredient, index) => (
      <Ingredient
        key={index}
        ingredient={ingredient}
        onPress={() => {
          addIngredient(ingredient);
          setIngredientsSearchPhrase('');
          if (onPick) onPick();
        }}
      />
    ));
    ingredients_list.push((
      <NewIngredient
        name={current_search_phrase}
        key={ingredients_search_results.length}
        onPress={() => {
          postIngredient(
            {name: current_search_phrase},
            /*success_callback*/(ing) => {
              addIngredient(ing);
              setIngredientsSearchPhrase('');
              if (onPick) onPick();
            },
            /*error_callback*/() => {
              if (onPick) onPick();
              pushNotification(
                NotificationSeverity.ERROR,
                t('inAppNotifications.postIngredientFailed'),
                3
              );
            }
          );
        }}
      />
    ));
    body = (
      <IngredientsList>
        { ingredients_list }
      </IngredientsList>
    );
  }

  return body;
}

export default IngredientPicker
